var exports = {
  "Qs": "x61f99309--31ab1f--content",
  "Kk": "x61f99309--31ab1f--icon",
  "rf": "x61f99309--31ab1f--body",
  "Qq": "x61f99309--31ab1f--text",
  "x6": "x61f99309--31ab1f--button",
};

module.exports = exports;
